module.exports = __webpack_public_path__ + "img/qrcode_wechat.e3160d7a.png";